export default {
  zh: {
    bindPhone: '绑定手机号',
    bindEmail: '绑定邮箱'
  },
  en: {
    bindPhone: 'Verify Phone',
    bindEmail: 'Verify Email'
  }
}



// WEBPACK FOOTER //
// ./src/components/account/bind/lang.js